import { markdownSerializer } from './serializer';
import { schema } from './editor-schema';

function jsonToDocusaurusConvertor(json) {
  const doc = schema.nodeFromJSON(json);
  return markdownSerializer.serialize(doc.content);
}

export { jsonToDocusaurusConvertor };
export default jsonToDocusaurusConvertor;
